import React from "react";
import { Flex } from "@jsq/ds/core";
import { BankAccountConfigurationTable } from "@jsq/payments-components";
import * as styles from "./styles_vanilla.css";

const BankAccountConfigurationPage: React.FC = () => {
  return (
    <Flex className={styles.pageContainer}>
      <BankAccountConfigurationTable />
    </Flex>
  );
};

export default BankAccountConfigurationPage;
